import { useCompanyInformationQuotaQuery } from "../queries/useCompanyInformationQuotaQuery";
import type { CompanyInformationQuotaState } from "../types";

/**
 * Hook for fetching company information quota.
 *
 * @note Company information quota has no `DataCredits` equivalent.
 * It is used mostly to gate trial users for company analysis data.
 */
export const useCompanyQuota = (enabled: boolean = true): CompanyInformationQuotaState => {
    const companyQuery = useCompanyInformationQuotaQuery(enabled);

    return {
        data: companyQuery.data,
        isQuotaUnlimited: Boolean(companyQuery.data?.isUnlimited),
        isQuotaReached: !!companyQuery.data && companyQuery.data.remaining <= 0,
    };
};
